/**
 * アクセストークンエラー
 */
function AuthenticationError (message) {
  this.message = message || '処理を継続するためにはログインが必要です。ログイン画面に遷移してよろしいですか？'
}
Object.setPrototypeOf(AuthenticationError, Error)
AuthenticationError.prototype = Object.create(Error.prototype)
AuthenticationError.prototype.name = 'AuthenticationError'
AuthenticationError.prototype.message = ''
AuthenticationError.prototype.constructor = AuthenticationError

/**
 * 投稿・報告バリデーションエラー
 */
function InputValidationError (message) {
  this.message = message || '問題が発生したため処理を継続することができませんでした。'
}

Object.setPrototypeOf(InputValidationError, Error)
InputValidationError.prototype = Object.create(Error.prototype)
InputValidationError.prototype.name = 'InputValidationError'
InputValidationError.prototype.message = ''
InputValidationError.prototype.constructor = InputValidationError

export default {
  AuthenticationError,
  InputValidationError
}



// WEBPACK FOOTER //
// ./src/api/errors.js